<div class="flex gap-x-3">
  <parkour-icon [name]="icon" size="3" />

  <div class="space-y-1">
    <p class="typo-body variant-body-fat">{{ title }}</p>

    <p class="typo-body text-n-600">{{ description }}</p>
  </div>
</div>
